import React from 'react';
import posed from 'react-pose';

const ViewItemContainer = posed.div({
  enter: {
    delayChildren: 200,
    staggerChildren: 50,
  },
  exit: {
    delay: 300,
  },
});

const ViewItem = posed.div({
  enter: {
    opacity: 1,
    transform: 'translate3d(0px, 0px, 0px)',
  },
  exit: {
    opacity: 0,
    transform: 'translate3d(0px, 20px, 0px)',
  },
});

export const View: React.FC<React.HTMLAttributes<HTMLDivElement>> = ({ children, ...props }) => {
  return (
    <ViewItemContainer {...props}>
      {React.Children.map(children, child => {
        return <ViewItem>{child}</ViewItem>;
      })}
    </ViewItemContainer>
  );
};
